<template>
    <v-row no-gutters class="bg-primary rounded-lg mb-10" justify="center">
        <v-col cols="12" sm="12" md="8" lg="8" xl="8" class="text-md-center text-lg-center text-xl-center">
            <div class="text-welcome pt-8 px-5 pb-3 font-weight-black">{{ $t('referrers.welcome') }}, <span class="text-warning">{{ referralPartner.name }}</span>
            </div>
            <div class="text-body-2 pb-3 px-5">{{ $t('referrers.personal_page') }}
            </div>
            <div
                class="bg-info d-flex d-sm-flex d-md-inline-flex d-lg-inline-flex d-xl-inline-flex py-4 rounded-lg my-4 my-md-8 my-lg-8 my-xl-8 mx-5">
                <div
                    class="text-body-2 px-md-10 px-lg-10 px-xl-10 text-center"
                    :class="$vuetify.display.smAndDown?'flex-1-1':''"
                ><span class="text-h5 font-weight-bold">{{ referralPartner.referral_potential_customers.length }}</span> {{ $t('referrers.referrals') }}
                </div>
                <v-divider vertical></v-divider>
                <div
                    class="text-body-2 px-md-10 px-lg-10 px-xl-10 text-center"
                    :class="$vuetify.display.smAndDown?'flex-1-1':''"
                ><span class="text-h5 font-weight-bold">{{ referralPartner.earned }} {{currency}}</span> {{ $t('referrers.earned') }}
                </div>
            </div>
        </v-col>
    </v-row>
</template>
<script>
export default {
    name: "WelcomeDashboard",
    props: {
        referralPartner: {
            type: Object,
            required: true,
        },
    },
    computed: {
        currency() {
            return process.env.MIX_APP_CURRENCY || "zł";
        },
    }
}
</script>

<style scoped lang="scss">
.text-welcome {
    font-size: 42px;
    @media (max-width: 959px) {
        font-size: 24px;
    }
}
</style>
